import { routerFrom } from "router";

export const routes = [
  {
    acl: ["ADMIN", "MANAGER", "PRIVATE"],
    label: "Message Center",
    name: "message-center",
    path: "/app/message-center",
    testName: "message-center",
  },
  {
    acl: ["ADMIN", "MANAGER", "PRIVATE"],
    label: "Message Center Conversation",
    name: "message-center.conversation",
    path: "/app/message-center/:conversationId",
    testName: "message-center-conversation",
  },
];

export const router = routerFrom(routes);
